import { memo } from 'react'
import { isEqual } from 'lodash'
import TradeUnionMemberManagementContainer from 'app/containers/TradeUnionMemberManagement'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const TradeUnionMemberManagementCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.trade_union_members_management)}</PageTitle>
      <TradeUnionMemberManagementContainer />
    </>
  )
}
export const TradeUnionMemberManagementPage = memo(TradeUnionMemberManagementCpn, isEqual)
